export default __webpack_public_path__ + "static/media/routesquare-light.009a07d0.svg";